import template from './transfer-alias-input.html';

export default angular
  .module('app.holding.dashboard.settings-profile')
  .directive('holdingTransferAliasInput', holdingTransferAliasInput)
  .name;

function holdingTransferAliasInput() {
  'ngInject';

  const directive = {
    link,
    template,
    restrict: 'E',
    require: 'ngModel',
    scope: true,
  };
  return directive;

  function prepareInput(value) {
    if (!value) {
      return value;
    }
    return value.trim().replace(/[^0-9a-z]/gi, '').toUpperCase();
  }

  function link(scope, _element, _attrs, ctrl) {
    scope.ctrl = ctrl;
    scope.model = {};
    scope.$watch('model.value', (value) => {
      if (value) {
        const newValue = prepareInput(value);
        scope.model.value = newValue;
        ctrl.$setViewValue(newValue);
      }
    });

    ctrl.$formatters.push((value) => {
      scope.model.value = value;
    });
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/settings/directives/transfer-alias-input/transfer-alias-input.js